/**
 * @generated SignedSource<<c82055ea5debe147c3ca6c2702a32c87>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type actionButtonsTracking_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly firstPhotoWebPath: string | null;
  readonly localizedPdpUrl: string | null;
  readonly pricing: {
    readonly totalAmount: {
      readonly convertedAmounts: {
        readonly AUD: number | null;
        readonly CAD: number | null;
        readonly CHF: number | null;
        readonly DKK: number | null;
        readonly EUR: number | null;
        readonly GBP: number | null;
        readonly MXN: number | null;
        readonly NOK: number | null;
        readonly SEK: number | null;
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "actionButtonsTracking_item";
};
export type actionButtonsTracking_item$key = {
  readonly " $data"?: actionButtonsTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionButtonsTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "actionButtonsTracking_item"
};

(node as any).hash = "76b3aa584c680d3721358eea130c9483";

export default node;
